<template>
  <div>
    <b-modal
      v-model="show"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      :id="theme"
      header-class="my-class"
      size="sm"
      title="Create hospital"
      ref="modal-edit"
    >
      <template #modal-header="{ close }" class="bg-dark">
        <!-- Emulate built in modal header close button action -->
        <p
          class="w-100 pt-3 text-center text-white h-100"
          size="sm"
          disabled
          variant="outline-danger"
          @click="close()"
        >
          パスワード再設定
        </p>
      </template>

      <div class="row">
        <div class="col-12 mt-2">
          <b-form-group class="password" label-for="username">
            <label class="text-label"
              >現在のパスワード
              <span
                class="
                  text-label-required
                  bg-required-label
                  badge badge-soft-danger
                  font-size-11
                  me-2
                "
                >必須</span
              ></label
            >
            <input
              class="form-control"
              @input="removeError('current_password')"
              maxlength="128"
              for="email"
              :type="types.current_password ? `text` : `password`"
              v-model.trim="dataInsert.current_password"
            />
            <div class="eye" @click="showHide('current_password')">
              <img
                src="@/assets/images/show.svg"
                v-if="types.current_password"
              />
              <img
                src="@/assets/images/hide.svg"
                v-if="!types.current_password"
              />
            </div>
          </b-form-group>
          <div
            v-if="errors.current_password"
            class="text-danger label fw-400"
            v-html="
              $t(`MSG.${messages.current_password}`).replace(
                ':field',
                $t('filed.current_password')
              )
            "
          ></div>
        </div>

        <div class="col-12">
          <b-form-group class="mt-3 password" label-for="email">
            <label class="text-label"
              >新しいパスワード
              <span
                class="
                  text-label-required
                  bg-required-label
                  badge badge-soft-danger
                  font-size-11
                  me-2
                "
                >必須</span
              ></label
            >
            <input
              class="form-control"
              @input="removeError('new_password')"
              maxlength="128"
              for="email"
              :type="types.new_password ? `text` : `password`"
              v-model.trim="dataInsert.new_password"
            />
            <div class="eye" @click="showHide('new_password')">
              <img src="@/assets/images/show.svg" v-if="types.new_password" />
              <img src="@/assets/images/hide.svg" v-if="!types.new_password" />
            </div>
          </b-form-group>
          <div
            v-if="errors.new_password"
            class="text-danger label fw-400"
            v-html="
              $t(`MSG.${messages.new_password}`).replace(
                ':field',
                $t('filed.new_password')
              )
            "
          ></div>
        </div>

        <div class="col-12">
          <b-form-group class="mt-3 password" label-for="phone">
            <label class="text-label"
              >新しいパスワード（確認用）
              <span
                class="
                  text-label-required
                  bg-required-label
                  badge badge-soft-danger
                  font-size-11
                  me-2
                "
                >必須</span
              ></label
            >
            <input
              class="form-control"
              @input="removeError('new_password_confirmation')"
              maxlength="128"
              for="phone"
              :type="types.new_password_confirmation ? `text` : `password`"
              v-model.trim="dataInsert.new_password_confirmation"
            />
            <div class="eye" @click="showHide('new_password_confirmation')">
              <img
                src="@/assets/images/show.svg"
                v-if="types.new_password_confirmation"
              />
              <img
                src="@/assets/images/hide.svg"
                v-if="!types.new_password_confirmation"
              />
            </div>
          </b-form-group>
          <div
            v-if="errors.new_password_confirmation"
            class="text-danger label fw-400"
            v-html="
              $t(`MSG.${messages.new_password_confirmation}`).replace(
                ':field',
                $t('filed.new_password_confirmation')
              )
            "
          ></div>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 row p-0">
          <div class="col-6 p-0" style="padding-right: 2px !important">
            <b-button
              class="w-100"
              type="button"
              @click="closeModal()"
              variant="outline-danger"
            >
              キャンセル
            </b-button>
          </div>
          <div class="col-6 p-0">
            <b-button
              type="button"
              @click="submit"
              class="w-100 btn-lyg"
              style="padding-left: 2px !important"
              variant="primary"
            >
              保存
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mixin } from "@/helpers/Vue-Mixin";
import { authMethods } from "@/state/helpers";

export default {
  props: ["isShow", "theme"],
  data() {
    return {
      dataInsert: {
        current_password: "",
        new_password: "",
        new_password_confirmation: "",
      },
      types: {
        current_password: false,
        new_password: false,
        new_password_confirmation: false,
      },
      errors: {
        current_password: false,
        new_password: false,
        new_password_confirmation: false,
      },
      messages: {
        current_password: "",
        new_password: "",
        new_password_confirmation: "",
      },
      show: false,
    };
  },

  mixins: [mixin],

  watch: {
    isShow: {
      handler(value) {
        this.show = JSON.parse(value);
      },
    },
  },

  created() {
    this.show = JSON.parse(this.isShow);
  },

  computed: {},

  methods: {
    ...authMethods,
    init() {
      this.dataInsert.current_password = "";
      this.dataInsert.new_password = "";
      this.dataInsert.new_password_confirmation = "";

      this.types.current_password = false;
      this.types.new_password = false;
      this.types.new_password_confirmation = false;

      this.errors.current_password = false;
      this.errors.new_password = false;
      this.errors.new_password_confirmation = false;

      this.messages.current_password = "";
      this.messages.new_password = "";
      this.messages.new_password_confirmation = "";
    },
    showHide(type) {
      this.types[type] = !this.types[type];
    },

    closeModal() {
      this.$emit("closeModal");
      this.show = false;
      this.init();
    },

    async submit() {
      try {
        this.errors.current_password = this.validateCurrentPassword();
        this.errors.new_password = this.validateNewPassword();
        this.errors.new_password_confirmation = this.validateConfirmPassword();
        if (
          !(
            this.errors.current_password ||
            this.errors.new_password ||
            this.errors.new_password_confirmation
          )
        ) {
          this.confirm(
            {
              title: "確認",
              text: "確認してもよろしいですか？",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: this.theme === 'normal' ? '#8fc31f' : '#395299',
              cancelButtonColor: "#FF5858",
              confirmButtonText: "はい",
              cancelButtonText: "いいえ",
            },
            async (e) => {
              // eslint-disable-next-line no-console
              if (e.isConfirmed) {
                try {
                  await this.changePassword(this.dataInsert);
                  this.closeModal();
                  window.toastr.success("パスワードのリセットに成功しました");
                } catch (error) {
                  // eslint-disable-next-line no-console
                  console.log(error);
                  this.errors[error.errors.fieldName] = true;
                  this.messages[error.errors.fieldName] = error.message;
                }
              }
            }
          );
        }
      } catch (error) {
        this.alertError();
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    validateCurrentPassword() {
      let error = false;
      if (this.dataInsert.current_password.trim() === "") {
        error = true;
        this.messages.current_password = "MSG_001";
      }

      return error;
    },
    validateNewPassword() {
      let error;
      const newPassword = this.dataInsert.new_password.trim();
      if (newPassword === "") {
        error = true;
        this.messages.new_password = "MSG_001";
      } else if (this.securePasswordRule(newPassword)) {
        error = true;
        this.messages.new_password = "MSG_027";
      } else {
        error = false;
      }

      return error;
    },
    validateConfirmPassword() {
      let error;
      const confirmPassword = this.dataInsert.new_password_confirmation.trim();
      if (confirmPassword === "") {
        error = true;
        this.messages.new_password_confirmation = "MSG_001";
      } else if (confirmPassword !== this.dataInsert.new_password) {
        error = true;
        this.messages.new_password_confirmation = "MSG_020";
      } else {
        error = false;
      }

      return error;
    },
    securePasswordRule(password) {
      const pattern = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]{8,128})$/;
      const regex = new RegExp(pattern);

      return !regex.test(password);
    },
    removeError(type) {
      this.errors[type] = false;
    },
  },
};
</script>

<style scoped>
::v-deep .my-class {
  background: #007e41;
  font-weight: 700;
  color: #ffffff;
  font-size: 20px;
}

* {
  font-family: "Noto Sans JP";
}
::placeholder {
  font-family: "Noto Sans JP";
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-button {
  font-weight: 700 !important;
}

::-webkit-input-placeholder {
  font-family: "Noto Sans JP";
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  font-weight: 400 !important;
  color: #404040;
}

.text-label {
  font-weight: 500 !important;
  color: #404040;
}

.text-label-required {
  font-weight: 500 !important;
  color: #f5f5f5;
}

.bg-required-label {
  background: #ff5858 !important;
}

.text-label-filter {
  font-weight: 700 !important;
  color: #404040 !important;
}

.text-link {
  color: #336aff;
}
.password {
  position: relative;
}
.eye {
  position: absolute;
  bottom: 5px;
  right: 15px;
  cursor: pointer;
}
</style>
